import {Suspense, useEffect} from 'react';
import Layout from './layout';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// import pages
import Home from './views/Home';
import Report from './views/Report';
import Projects from './views/Projects';
import WhiteHat from './views/WhiteHat';
import About from './views/About';
import Login from './views/Login';

import Register from './views/Register';
// companyregister

import CompanyRegister from './views/CompanyRegister';
import ReportDetail from './views/Report/detail';
import Search from './views/Search';
import User from './views/User';
// common tips
import CommonTips from './views/commonTips/index';
import ProjectsDetail from './views/Projects/components/ProjectsDetail';
import AuthorDetail from './views/WhiteHat/components/AuthorDetail';
import AddReport from './views/AddReport';
import AddTeam from './views/AddTeam';
import VerifyEmailTips from './views/Verify/verifyEmail';
import RegisterVerifyEmail from './views/Verify/registerVerify';
import ForGetPassword from './views/Login/forgetPassword';
import ResetPassword from './views/Login/resetPassword';
import TwoFA from './views/Login/twoFA';
import PageContent from "./components/PageContent";
import {Spin} from "antd";
import {SecurityTeamDetail} from "./views/SecurityTeam/components/SecurityTeamDetail";
import {SecurityTeam} from "./views/SecurityTeam";
import {WalletEmailBind} from "./views/Login/WalletEmailBind";
import {Contests} from "./views/Contests";
import {useLocation} from "react-router";
import {AdminSetPassword} from "./views/AdminSetPassword";
import {ChangeEmail} from "./views/ChangeEmail";

// loading components
export const Loading = () => {
  return (
    <PageContent>
      <Spin delay={1000} />
    </PageContent>
  );
};

// default route
const NOTFUND = () => {
  return <div>404 NOT FOUND</div>;
};

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100)
  }, [pathname]);

  return null;
}

export const Router = () => {
  return (
      <BrowserRouter>
        <Suspense fallback={<Loading />}>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home/>}/>
              <Route path="/reports" element={<Report />} />
              <Route
                  path="/reports/:serial_number"
                  element={<ReportDetail />}
              />
              <Route path="/bounties" element={<Projects />} />
              <Route
                  path="/bounties/:id"
                  element={<ProjectsDetail />}
              />
              <Route path="/contests" element={<Contests />} />
              <Route path="/whiteHats" element={<WhiteHat />} />
              <Route
                  path="/whiteHats/:id"
                  element={<AuthorDetail />}
              />
              {/* <Route path="/team" element={<Team />} /> */}
              {/* <Route path="/team/detail/:id" element={<TeamDetail />} /> */}
              <Route path="/whitehat-teams" element={<SecurityTeam />} />
              <Route path="/whitehat-teams/:title" element={<SecurityTeamDetail />} />
              {/* <Route path="/articles" element={<Articles />} /> */}
              <Route path="/about" element={<About />} />
              {/* <Route
                path="/articles/detail/:id"
                element={<ArticlesDetail />}
               /> */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route
                  path="/project/register"
                  element={<CompanyRegister />}
              />
              <Route path="/search" element={<Search />} />
              <Route path="/user" element={<User />} />
              <Route path="/addreport" element={<AddReport />} />
              <Route path="/addteam" element={<AddTeam />} />
              <Route
                  path="/register/verfiytip"
                  element={<VerifyEmailTips />}
              />
              <Route
                  path="/users/email_verify"
                  element={<RegisterVerifyEmail />}
              />
              <Route
                  path="/wallet_email_bind"
                  element={<WalletEmailBind />}
              />
              <Route
                  path="users/forget_password_send_email"
                  element={<ForGetPassword />}
              />
              <Route
                  path="users/forget_password"
                  element={<ResetPassword />}
              />
              <Route path="info/tips" element={<CommonTips />} />
              <Route path="change-email" element={<ChangeEmail />} />
              <Route path="*" element={<NOTFUND />} />
              <Route path="/login/2fa" element={<TwoFA />} />
              <Route path="/users/company_admin" element={<AdminSetPassword />} />
            </Routes>
          </Layout>
        </Suspense>
      </BrowserRouter>
  )
}
